// auth0.js
export default{domain:'192.168.2.20',clientId:'YOUR_CLIENT_ID'};